import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LayoutRoutingModule } from './layout-routing.module';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { HeaderComponent } from './header/header.component';
import { UiModule } from '@ui/ui.module';
import { GlobalSearchModule } from '@ui/global-search/global-search.module';
import { UiV2Module } from '@app/ui-v2/ui-v2.module';
import { IconsModule } from '@app/icons/icons.module';
import { PipesModule } from '@app/ui/pipes/pipes.module';
import { AlertsModule } from '@app/shared/components/alerts/alerts.module';
import { LeadBoostModule } from '@app/lead-boost/lead-boost.module';
import { AgentSubstitutionFormComponent } from '@app/shared/forms/agent-substitution-form/agent-substitution-form.component';
import { TeamLeadSubstitutionFormComponent } from '@app/shared/forms/team-lead-substitution-form/team-lead-substitution-form.component';
import { FormlyModule } from '@ngx-formly/core';

@NgModule({
  declarations: [
    MainLayoutComponent,
    HeaderComponent,
    AgentSubstitutionFormComponent,
    TeamLeadSubstitutionFormComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    LayoutRoutingModule,
    UiModule,
    UiV2Module,
    GlobalSearchModule,
    IconsModule,
    PipesModule,
    AlertsModule,
    LeadBoostModule,
  ],
})
export class LayoutModule {}
